import { Box, Grid, Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

type Props = {
  xsCols: [number, number];
  label: string;
  fieldComponent: ReactElement;
  labelActions?: ReactNode;
};

const LabelFieldRow = ({ xsCols, label, fieldComponent, labelActions }: Props) => (
  <>
    <Grid item textAlign="end" alignSelf="center" xs={xsCols[0]}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        gap={1}
        flexWrap="wrap"
      >
        <Typography variant="secondary">{label}</Typography>
        {labelActions}
      </Box>
    </Grid>
    <Grid item xs={xsCols[1]}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="173px"
      >
        {fieldComponent}
      </Box>
    </Grid>
  </>
);

export default LabelFieldRow;
